"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const logger = (msg) => {
    console.error(`%c [enable3d] ${msg} `, 'background: #222; color: #bada55');
};
exports.default = logger;
//# sourceMappingURL=logger.js.map